import styled from 'styled-components';
import { Button } from '../UI-CHAKRA/Button';
import { MenuButton } from '../UI-CHAKRA/Menu/MenuButton';
import { MenuItem } from '../UI-CHAKRA/Menu/MenuItem';
import colorContrast from 'color-contrast';

export const ItemIconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 25px;
    width: 20px;
  }
`;

export const BorderBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 20px 0;
  width: 4px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  border-radius: 10px 0 0 10px;
  overflow: hidden;

  div:not(:first-child) {
    margin-top: 2px;
  }

  div:not(:last-child) {
    margin-bottom: 2px;
  }
`;

export const ContraindicatedBox = styled.div`
  height: 100%;
  width: 100%;
  background-color: #bf0711;
  border-radius: 20px;
`;

export const MajorBox = styled.div`
  height: 100%;
  width: 100%;
  background-color: #fead9a;
  border-radius: 20px;
`;

export const ModerateBox = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffc58b;
  border-radius: 20px;
`;

export const MinorBox = styled.div`
  height: 100%;
  width: 100%;
  background-color: #eec200;
  border-radius: 20px;
`;

export const StyledMenuItem = styled(MenuItem)`
  height: 50px;
  border-radius: 20px;
  &:hover {
    background-color: #f1f7ff !important;
  }

  &.active {
    color: ${({ theme }) => (colorContrast('#fff', theme.palette.primary.main) > 3 ? 'white' : '#1E252B')};
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const StyledButton = styled(Button)`
  text-transform: none;
  border-color: #f1f3f5 !important;
  font-size: 16px;
  line-height: 14px;
  height: 50px !important;
  box-shadow: 0px 6px 16px rgba(35, 82, 164, 0.06);
  border: 0px;
  box-sizing: border-box;
  white-space: nowrap;
  padding: 13px 16px !important;
  border-radius: 20px !important;
  font-family: Ambit-Regular, Inter, sans-serif;

  &.active {
    border-color: ${({ theme }) => theme.palette.primary.main} !important;
  }
  &.active:hover {
    border-color: ${({ theme }) => theme.palette.primary.main} !important;
  }
  &:hover {
    box-shadow: 0px 6px 16px rgba(35, 82, 164, 0.1);
    border: 0px;
  }
`;

export const StyledMenuButton = styled(MenuButton)`
  text-transform: none;
  border-color: #f1f3f5 !important;
  font-size: 16px;
  line-height: 14px;
  margin-right: 16px;
  height: 50px !important;
  border: 0px;
  box-sizing: border-box;
  white-space: nowrap;
  padding: 17px 15px;
  border-radius: 20px;
  box-shadow: 0px 6px 16px rgba(35, 82, 164, 0.06);
  margin-right: 0;
  background-color: #fff;
  font-family: Ambit-Regular, Inter, sans-serif;
  font-weight: bold;
  &:hover {
    box-shadow: 0px 6px 16px rgba(35, 82, 164, 0.1);
    border: 0px;
  }

  &.active {
    color: ${({ theme }) => (colorContrast('#fff', theme.palette.primary.main) > 3 ? 'white' : '#1E252B')};
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`;
